 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPY from '@/components/xhtml/copy'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLCONTENTS1 from '@/components/xhtml/contents1'
 import XHTMLINTRO from '@/components/xhtml/intro'
 import XHTMLVEG from '@/components/xhtml/veg'
 import XHTMLFISH from '@/components/xhtml/fish'
 import XHTMLBAKING from '@/components/xhtml/baking'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLBCOVER from '@/components/xhtml/bcover'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/contents1",
 			"name" : "xhtml/contents1",
 			"component" : XHTMLCONTENTS1
 		},
 		{
 			"path" : "/xhtml/intro",
 			"name" : "xhtml/intro",
 			"component" : XHTMLINTRO
 		},
 		{
 			"path" : "/xhtml/veg",
 			"name" : "xhtml/veg",
 			"component" : XHTMLVEG
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js